var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.audioList),function(item){return _c('audio',{key:item.userId,staticStyle:{"display":"none"},attrs:{"id":("audio-" + (item.userId)),"autoplay":""}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }